import styled from "styled-components/macro";

export const CfcReviewSubtitle = styled.p`
  margin: 0 0 24px;
  font-size: 14px;
  font-family: light;
  color: ${({ theme }) => theme.greyDark};
  line-height: 1.5;
`;

export const CfcReviewInfoGrid = styled.dl`
  display: grid;
  grid-template-columns: 180px 1fr;
  row-gap: 8px;
  column-gap: 24px;
  margin-top: 0;
  margin-bottom: 32px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    row-gap: 4px;
  }
`;

export const CfcReviewInfoLabel = styled.dt`
  font-size: 14px;
  font-family: light;
  color: ${({ theme }) => theme.greyDark};
`;

export const CfcReviewInfoValue = styled.dd`
  margin: 0;
  font-size: 14px;
  font-family: bold;
  color: ${({ theme }) => theme.greyDark};
`;

export const CfcReviewLinks = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CfcReviewLink = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  height: 45px;
  padding: 0 16px 0 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.redMedium};
  font-size: 18px;
  line-height: 28px;
  font-family: bold;

  svg {
    font-size: 15px;
  }

  &:hover {
    opacity: 0.8;
  }
`;
